import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const DropdownComponent = (props) => {
    const [selectedValue, setSelectedValue] = useState(null);

    useEffect(() => {        
        if (props.defaultSelected && !selectedValue) {
            handleOnChange(props.defaultSelected);            
        } else {
            handleOnChange(selectedValue);
        }
    }, [props.dropDownData, props.defaultSelected]);


    const handleOnChange = (itemData) => {
        setSelectedValue(itemData);
        if (props.fetchBySelectedValue) {
          console.log("selectedClassValue",itemData);
          if(localStorage.getItem('classId') != null){
            let obj = JSON.parse(localStorage.getItem('classId'));
            setSelectedValue(obj)
            props.fetchBySelectedValue(obj.id);
            localStorage.removeItem('classId');
          } else{
            props.fetchBySelectedValue(itemData.id);
          }
          
        }
    };

    return (
        <FormControl sx={{ minWidth: ((props.minWidth) ? props.minWidth : 120) ,px: 1 }} size="small">
            <Select
                placeholder="Class"
                disabled={props.disableVal ? props.disableVal : false}
                value={selectedValue}                
                renderValue={(selected) => `${selected.value}`}
                sx={{borderRadius: 20, borderColor: '#5f5600ff', color: '#5f5600ff', fontWeight: '500', '@media (min-width: 1636px)': {
                    fontSize: '1.4rem',
                    width: '36ch',
                    mt: 0.5
                  }}}
            >
                {props.dropDownData.map((itemData, index) => (
                    <MenuItem 
                        sx={{color: '#5f5600ff', fontSize: '0.8rem', fontWeight: '500','@media (min-width: 1636px)': {fontSize: '1.2rem'} }} 
                        key={`${index}_Class`} 
                        value={itemData} 
                        onClick={() => handleOnChange(itemData)}
                    >
                        {itemData.value}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default DropdownComponent;